import { call, SagaGenerator, select } from "typed-redux-saga";

import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { DataOperation } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";
import { Query } from "@com.mgmtp.a12.dataservices/dataservices-access";

import { ModulfOverviewEngineDataLoader } from "../../app/provider/modulfOverviewEngineDataLoader";
import { assertNonNullable } from "../../utilities/assert";
import { queryLinkedProcessed } from "../../utilities/rpcHelper";

import { dataModels } from "./moduleResources";

/**
 * An overview engine loader that adds a fixed filter for processId to the query (so that the user can only see Fristen
 * belonging to the current Antrag)
 */
export const linksLoader: ModulfOverviewEngineDataLoader = {
	*canHandle(params): SagaGenerator<boolean> {
		const { documentModel, activityId } = params;
		if (documentModel.header.id !== dataModels.GENERIC_PROCESS_MODEL) {
			return false;
		}

		const activity = yield* select(ActivitySelectors.activityById(activityId));
		return activity?.descriptor.view === "links" && !!activity.descriptor.reference;
	},
	*provideData(params): SagaGenerator<DataOperation.ResultSet> {
		const activity = yield* select(ActivitySelectors.activityById(params.activityId));
		assertNonNullable(activity?.descriptor.reference);

		const results: Query.DocumentTreeResult[] | undefined = yield* call(
			queryLinkedProcessed,
			activity.descriptor.reference
		);

		if (!results) {
			return { queryResults: [] };
		}

		const documents = results.map(result => ({
			id: result.docRef,
			modelId: result.documentModelName ?? result.docRef.split("/").slice(1).join("/"),
			...params.documentService.parseDates(result.document, params.documentModel)
		}));

		return {
			queryResults: [
				{
					id: "",
					fullSize: results.length,
					documents
				}
			]
		};
	}
};
